/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import CloseButton from '../../components/buttons/CloseButton';
import {dlsColor} from '../../theme/theme';

export type CreateGeofenceCardHeaderProps = {
  onClose: () => void;
  title?: string;
};

const useStyles = makeStyles(() => ({
  header : {
    display        : 'flex',
    flexShrink     : 0,
    alignItems     : 'center',
    justifyContent : 'space-between',
    height         : 56,
    padding        : '0 8px 0 16px'
  },
  title : {
    fontFamily : 'Inter',
    fontWeight : 600,
    fontSize   : '16px',
    lineHeight : '20px',
    color      : dlsColor('grey1')
  }
}));

/**
 * Renders the current theme's geofence card header - its title and close
 * button - shared by the create card's location and save steps and by the
 * vicinity search card.
 *
 * ```typescript
 *
 *   import {CreateGeofenceCardHeader} from
 *     '@ion/dls/src/maps/geofences/CreateGeofenceCardHeader';
 *   ...
 *
 *   <CreateGeofenceCardHeader onClose={onClose} />
 *
 * ```
 *
 * @param   onClose Invoked when the close button is clicked.
 * @param   title   The header title; the create card's title by default.
 * @returns         The card header.
 */
export const CreateGeofenceCardHeader = ({onClose, title}: CreateGeofenceCardHeaderProps) => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <span className={classes.title}>
        {title ?? translate('maps:geofences.createCard.title')}
      </span>
      <CloseButton onClick={onClose} />
    </div>
  );
};

export default CreateGeofenceCardHeader;
